export default function CNestedLoops() {
  return <h2>C Nested Loops</h2>;
}
